import React from 'react';
import { TextField, FormControl } from '@mui/material';
import { Field } from 'formik';

interface NamedUrlFieldProps {
    urlFieldName: string;
    urlFieldLabel?: string;
    nameFieldName: string;
    nameFieldLabel?: string;
    urlFieldError?: any;
    nameFieldError?: any;
    urlFieldHelperText?: string | boolean;
    nameFieldHelperText?: string | boolean;
}

const NamedUrlField: React.FC<NamedUrlFieldProps> = ({
    urlFieldName,
    urlFieldLabel = 'URL',
    nameFieldName,
    nameFieldLabel = 'URL Name',
    urlFieldError = null,
    nameFieldError = null,
    urlFieldHelperText = undefined,
    nameFieldHelperText = undefined,
}) => {
    return (
        <FormControl
            fullWidth
            sx={{
                marginBottom: 2,
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
            }}
        >
            <Field
                as={TextField}
                sx={{ width: '65%' }}
                name={urlFieldName}
                label={urlFieldLabel}
                variant="outlined"
                size="small"
                error={urlFieldError}
                helperText={urlFieldHelperText}
            />
            <Field
                as={TextField}
                sx={{ width: '35%' }}
                name={nameFieldName}
                label={nameFieldLabel}
                variant="outlined"
                size="small"
                error={nameFieldError}
                helperText={nameFieldHelperText}
            />
        </FormControl>
    );
};

export default NamedUrlField;
